import { Box, Button, IconButton, Tooltip } from '@chakra-ui/react';
import { useState } from 'react';
import { PiTrash } from 'react-icons/pi';

import { Equipment } from '@app/api/models';
import { ConfirmRemoveDialog, Dialog, Txt } from '@app/components/common';
import { checkboxBodyRender, entityBaseBodyRender, QueryTable, Table } from '@app/components/common/table';
import { FieldComponentProps } from '@app/components/common/types';
import { useApi, useFetchData } from '@app/hooks';
import { RequestPayload } from '@app/api';

import { PasteDialog } from './PasteDialog';


export const EquipsField = ({ value, onChange, outlet, disabled }: FieldComponentProps<Equipment[]> & { outlet?: EntityBase }) => {
  const [open, setOpen] = useState(false);
  const [openBufferInsert, setOpenBufferInsert] = useState(false);
  const api = useApi();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedEquips, setSelectedEquips] = useState<Equipment[]>([]);
  
  const onSelect = () => {
    onChange(selectedEquips);
    setOpen(false);
  };  

  const onRemove = (id) => () => {
    onChange(value.filter((equip) => equip.id !== id));
  };

  const onClear = () => {
    onChange([]);
  };

  const [fetchData] = useFetchData({ method: (payload: RequestPayload) => api.equipments.getEquipmentsOutlet(outlet.id, payload) });

  return <Box>
    <Box mx={-5} mt={-4}>
      <Table<Equipment>
        title={<Txt fontSize='medium'>Холодильное оборудование</Txt>}
        columns={[
          { name: 'id', label: '#', options: { filter: false } },
          { name: 'model', label: 'Модель', options: { 
            customBodyRender: entityBaseBodyRender(),
            filter: {
              name: 'model_id',
              sourceName: 'equipment_model',
              type: 'multi-select',
            },
          } },
          { name: 'inventory_num', label: 'Инв.номер', options: { filter: true } },
          { name: 'serial_num', label: 'Серийный номер', options: { filter: true } },
          { name: 'production_date', label: 'Год производства', options: { filter: true } },
          { name: 'id', label: 'Удалить', options: { 
              filter: false,
              customBodyRender: (id) => <ConfirmRemoveDialog text='Удалить?' onRemove={onRemove(id)} />
            }   
          }
        ]} 
        data={value || []}
        disabled={disabled}
        createMenu={[
          { id: 'list', title: 'Выбрать из списка' },
          { id: 'insert', title: 'Вставить из буфера' },
        ]}
        onCreateClick={({ id }) => id === 'insert' ? setOpenBufferInsert(true) : setOpen(true)}
        additionalToolbar={
          <Box display='flex' gap={2} ml={4}>
            <Tooltip label='Удалить все'>
              <IconButton variant="outline" colorScheme='brand' onClick={onClear} aria-label="">
                <PiTrash/>
              </IconButton>
            </Tooltip>
          </Box>}
        />
    </Box>
    <PasteDialog
      open={openBufferInsert}
      outletId={outlet?.id.toString()}
      onClose={() => setOpenBufferInsert(false)}
      onSelect={onChange}
    />
    <Dialog 
      open={open}  
      title="Выбор ХО"  
      onClose={() => setOpen(false)} 
      width="fit-content"
      loading={isLoading}
      actions={[
        <Button key="ok" colorScheme='brand' onClick={onSelect}>Выбрать</Button>,
      ]}
    >
      <Box mx={-6} mb={-3} mt={-5}>
        <QueryTable<Equipment>
          ignoreQuery
          fetchData={fetchData}
          title=""
          columns={[
            { name: 'id', label: '', options: {
              customBodyRender: checkboxBodyRender<Equipment>({
                selected: selectedEquips,
                onChange: setSelectedEquips
              }),
            } },
            { name: 'id', label: '#', options: {} },
            { name: 'model', label: 'Модель', options: { 
              customBodyRender: entityBaseBodyRender(),
              filter: {
                name: 'model_id',
                sourceName: 'equipment_model',
                type: 'multi-select',
              },
            } },
            { 
              name: 'inventory_num', 
              label: 'Инв.номер', 
              options: { 
                filter: {
                  name: 'inventory_num',
                  type: 'text', 
                  onApply: (value: string) => [value],
                }
              } },
            { name: 'serial_num', label: 'Серийный номер', options: { 
              filter: {
                name: 'serial_num',
                type: 'text', 
                onApply: (value: string) => [value],
              },
             } },
            { name: 'production_date', label: 'Год производства', options: { filter: true } },
          ]} 
        />
      </Box>
    </Dialog>  
  </Box>;

};
